export const GO_TO_MODULE_CONNECTIONS = "GO_TO_MODULE_CONNECTIONS";
export const VOICE_STARTED = "voice-started";
export const VOICE_ENDED = "voice-ended";
export const VOICE_SPEAKING = "voice-speaking";
export const VOICE_WAITING = "voice-waiting";
export const VOICE_FORCE_END = "voice-force-end";
